import { useEffect, useState } from "react";
import { getSummaryTable, getSummaryTableByTournament } from "../../../api/transport/statsTransport";
//import { Loader } from "../../../components/Loader";
import { TournamentTableMini } from "../../../components/TournamentTable/TableMini";
import { SummaryTableDto } from "../../../types/stats/summaryTables";

interface SummaryTableMiniWidgetProps {
    summaryTableId?: number;
    tournamentLegacyId?: number;
}

export const SummaryTableMiniWidget: React.FC<SummaryTableMiniWidgetProps> = ({
    summaryTableId,
    tournamentLegacyId,
}) => {
    const [summaryTable, setSummaryTable] = useState<SummaryTableDto>();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (tournamentLegacyId) {
            getSummaryTableByTournament(tournamentLegacyId).then(data => {
                if (!data) {
                    return Promise.reject();
                }

                setSummaryTable(data);
            }).finally(() => {
                setLoading(false);
            })
        } else if (summaryTableId) {
            getSummaryTable(summaryTableId).then((data) => {
                if (!data) {
                    return Promise.reject();
                }

                setSummaryTable(data);
            }).finally(() => {
                setLoading(false)
            });
        } else {
            setLoading(false);
        }
    }, [summaryTableId, tournamentLegacyId]);

    if (loading) {
        return null;
    }

    if (!summaryTable?.tableData?.length) {
        return null;
    }

    return (
        <div className="px-2 pb-4 w-[200px]">
            <div className="transiton-all rounded-xl cursor-pointer hover:shadow-md overflow-hidden border border-gray-50" style={{ fontFamily: 'Futura, sans-serif' }}>
                <a href={`/tables/?shows=${summaryTable.id}`} title={"Перейти к " + summaryTable.name} className="text-sky-950 hover:no-underline">
                    <div className="text-sky-950 font-xl font-semibold pb-4 w-full text-center">Общий зачёт</div>
                    <TournamentTableMini
                        data={summaryTable?.tableData || []}
                        columns={['points']}
                        noLogos
                    />
                </a>
            </div>
        </div>
    );
}
